import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

import format from 'date-fns/format';
import msg from 'msg';

import Icon from 'widgets/Icon/Icon';
import QuantityControls from '../QuantityControls';

import {
  frequencyOptions,
  DEFAULT_FREQUENCY,
} from 'apps/subscriptions/components/fopPartials/SubscriptionsFrequencyOptions';

export default class Regulars extends PureComponent {
  static propTypes = {
    sku: PropTypes.string,
    frequency: PropTypes.string,
    quantity: PropTypes.number,
    nextAddDate: PropTypes.string,
    pending: PropTypes.bool,
    requestSubscribe: PropTypes.func,
    requestFrequencyChange: PropTypes.func,
    requestQuantityChangeOrDelete: PropTypes.func,
  };

  static defaultProps = {
    frequency: DEFAULT_FREQUENCY,
    quantity: 0,
  };

  state = {
    frequency: this.props.frequency,
  };

  componentDidUpdate(prevProps) {
    if (prevProps.sku !== this.props.sku) {
      this.clearForm();
    }
  }

  clearForm() {
    this.setState({ frequency: this.props.frequency || DEFAULT_FREQUENCY, quantity: 0 });
  }

  changeFrequency = (ev) => {
    const {
      sku,
      requestFrequencyChange,
      quantity,
    } = this.props;
    const frequency = ev.target.value;

    if (quantity) {
      requestFrequencyChange(sku, frequency);
    }
    this.setState({ frequency });
  };

  changeQuantity = (quantityDelta) => {
    const {
      sku,
      requestSubscribe,
      requestQuantityChangeOrDelete,
      quantity,
    } = this.props;
    const { frequency } = this.state;

    if (!quantity) {
      requestSubscribe({ sku, frequency });
    } else {
      requestQuantityChangeOrDelete(sku, quantityDelta);
    }
    this.setState(prevState => ({
      quantity: prevState.quantity + quantityDelta,
    }));
  };

  renderControls = () => {
    const {
      pending,
      quantity,
    } = this.props;
    const { frequency } = this.state;

    return (
      <div className="bop-regulars__frequency__wrapper">
        <select
          name="regulars_frequency"
          className="gn-select__field gn-select__field--small bop-regulars__frequency"
          onChange={this.changeFrequency}
          value={frequency}
        >
          {frequencyOptions.map(({ value, label }) => (
            <option key={value} value={value}>{label}</option>
          ))}
        </select>
        <QuantityControls
          classNamePrefix="bop-regularsControls"
          quantity={quantity}
          onUpdate={this.changeQuantity}
          isUpdating={pending}
          addButtonLabel="Select"
          addButtonType="secondary"
          buttonsSize="small"
        />
      </div>
    );
  };

  render() {
    const { nextAddDate } = this.props;
    return (
      <>
        <div className="bop-regulars__wrapper">
          <Icon name="regulars" />
          <p className="bop-regulars__header">
            {msg.retailer} Regulars
          </p>
          <p className="bop-regulars__description">
            Buy this often? Make it a Regular and we’ll add it to your trolley for you, as frequently as you’d like.
          </p>
          {this.renderControls()}
          {nextAddDate && (
            <p className="bop-regulars__nextAddDate gn-content__paragraph--small">
              This’ll be in your trolley on <b>Monday, {format(new Date(nextAddDate), 'Do MMMM')}</b>.
            </p>
          )}
        </div>
        <div className="gn-divider gn-divider--light bop-promotion__divider" />
      </>
    );
  }
}
